import { CompletionYearContainer } from '../../containers/advancedFilters/CompletionYearContainer';
import { IFilter } from '../../types/advancedFilters';

export const completionYear: IFilter = {
  component: CompletionYearContainer,
};
